'use client';

import ErrorPage from '@eliadmin/core/src/pages/error';
import { captureClientException } from '../performance/client-error-reporting';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }: any) {
  useEffect(() => {
    captureClientException(error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorPage error={error} reset={reset} />
      </body>
    </html>
  );
}
